import { call, put, takeLatest } from 'redux-saga/effects'

// redux
import * as growsmartApi from '../apiModules/growsmart'
import * as growsmartModule from '../modules/growsmart'

// utils
import UrlBuilder from 'utils/urlBuilder'

function* inviteMentor({ payload }) {
  try {
    delete payload.campaigns

    const response = yield call(growsmartApi.inviteMentor, payload)
    yield put(growsmartModule.inviteMentorSuccess(response))

    const { navigate } = payload
    yield navigate('/dashboard')
  } catch (err) {
    yield put(growsmartModule.inviteMentorFailure(err))
  }
}

function* declineInvite({ payload }) {
  try {
    const response = yield call(growsmartApi.declineInvite, payload)
    yield put(growsmartModule.declineInviteSuccess(response))
  } catch (err) {
    yield put(growsmartModule.declineInviteFailure(err))
  }
}

function* fetchRegistrations({ payload }) {
  try {
    const response = yield call(growsmartApi.fetchRegistrations, payload)
    yield put(growsmartModule.fetchRegistrationsSuccess(response))
  } catch (err) {
    yield put(growsmartModule.fetchRegistrationsFailure(err))
  }
}

function* fetchEnrolment({ payload }) {
  try {
    const response = yield call(growsmartApi.fetchEnrolment, payload)
    yield put(growsmartModule.fetchEnrolmentSuccess(response))
  } catch (err) {
    yield put(growsmartModule.fetchEnrolmentFailure(err))
  }
}

function* fetchEnrolments({ payload }) {
  try {
    const response = yield call(growsmartApi.fetchEnrolments, payload)
    yield put(growsmartModule.fetchEnrolmentsSuccess(response))
  } catch (err) {
    yield put(growsmartModule.fetchEnrolmentsFailure(err))
  }
}

function* fetchHardcopySubmissions({ payload }) {
  try {
    const response = yield call(growsmartApi.fetchHardcopySubmissions, payload)
    yield put(growsmartModule.fetchHardcopySubmissionsSuccess(response))
  } catch (err) {
    yield put(growsmartModule.fetchHardcopySubmissionsFailure(err))
  }
}

function* fetchSchoolsForProvince({ payload }) {
  try {
    const response = yield call(growsmartApi.fetchSchoolsForProvince, payload)
    yield put(growsmartModule.fetchSchoolsForProvinceSuccess(response))
  } catch (err) {
    yield put(growsmartModule.fetchSchoolsForProvinceFailure(err))
  }
}

function* fetchDistricts() {
  try {
    const response = yield call(growsmartApi.fetchDistricts)
    yield put(growsmartModule.fetchDistrictsSuccess(response))
  } catch (err) {
    yield put(growsmartModule.fetchDistrictsFailure(err))
  }
}

function* fetchRsvps() {
  try {
    const response = yield call(growsmartApi.fetchRsvps)
    yield put(growsmartModule.fetchRsvpsSuccess(response))
  } catch (err) {
    yield put(growsmartModule.fetchRsvpsFailure(err))
  }
}

function* fetchScholarships() {
  try {
    const response = yield call(growsmartApi.fetchScholarships)
    yield put(growsmartModule.fetchScholarshipsSuccess(response))
  } catch (err) {
    yield put(growsmartModule.fetchScholarshipsFailure(err))
  }
}

function* fetchScholarship({ payload }) {
  try {
    const response = yield call(growsmartApi.fetchScholarship, payload)
    yield put(growsmartModule.fetchScholarshipSuccess(response))
  } catch (err) {
    yield put(growsmartModule.fetchScholarshipFailure(err))
  }
}

function* createScholarship({ payload }) {
  try {
    const reg = yield call(growsmartApi.createScholarship, payload)
    yield put(growsmartModule.createScholarshipSuccess(reg))

    const { navigate } = payload
    yield navigate('/dashboard/scholarships')
  } catch (err) {
    yield put(growsmartModule.createScholarshipFailure())
  }
}

function* updateScholarship({ payload }) {
  try {
    const updatedReg = yield call(growsmartApi.updateScholarship, payload)
    yield put(growsmartModule.updateScholarshipSuccess(updatedReg))

    const { navigate } = payload
    yield navigate('/dashboard/scholarships')
  } catch (err) {
    yield put(growsmartModule.updateScholarshipFailure())
  }
}

function* deleteScholarship({ payload }) {
  try {
    const response = yield call(growsmartApi.deleteScholarship, payload)
    yield put(growsmartModule.deleteScholarshipSuccess(response.data))
    UrlBuilder.displayDeleteSuccessMessage()
  } catch (err) {
    yield put(growsmartModule.deleteScholarshipFailure(err))
  }
}

function* applyToScholarship({ payload }) {
  try {
    const formDataVals = new FormData()

    Object.keys(payload).map(value => {
      if (payload[value] && value !== 'navigate') {
        formDataVals.append(value, payload[value])
      }
    })

    const response = yield call(growsmartApi.applyToScholarship, formDataVals)
    yield put(growsmartModule.applyToScholarshipFailure(response.data))

    const { navigate } = payload
    return navigate('/dashboard/scholarships')
  } catch (err) {
    yield put(growsmartModule.applyToScholarshipSuccess(err))
  }
}

function* fetchScholarshipApplication({ payload }) {
  try {
    const response = yield call(growsmartApi.fetchScholarshipApplication, payload)
    yield put(growsmartModule.fetchScholarshipApplicationSuccess(response))
  } catch (err) {
    yield put(growsmartModule.fetchScholarshipApplicationFailure(err))
  }
}

function* fetchScholarshipApplications({ payload }) {
  try {
    const response = yield call(growsmartApi.fetchScholarshipApplications, payload)
    yield put(growsmartModule.fetchScholarshipApplicationsSuccess(response))
  } catch (err) {
    yield put(growsmartModule.fetchScholarshipApplicationsFailure(err))
  }
}

function* fetchSponsorships() {
  try {
    const response = yield call(growsmartApi.fetchSponsorships)
    yield put(growsmartModule.fetchSponsorshipsSuccess(response))
  } catch (err) {
    yield put(growsmartModule.fetchSponsorshipsFailure(err))
  }
}

function* fetchSponsorship({ payload }) {
  try {
    const response = yield call(growsmartApi.fetchSponsorship, payload)
    yield put(growsmartModule.fetchSponsorshipSuccess(response))
  } catch (err) {
    yield put(growsmartModule.fetchSponsorshipFailure(err))
  }
}

function* createSponsorship({ payload }) {
  try {
    const reg = yield call(growsmartApi.createSponsorship, payload)
    yield put(growsmartModule.createSponsorshipSuccess(reg))

    const { navigate } = payload
    return navigate('/dashboard/sponsorships')
  } catch (err) {
    yield put(growsmartModule.createSponsorshipFailure())
  }
}

function* updateSponsorship({ payload }) {
  try {
    const updatedReg = yield call(growsmartApi.updateSponsorship, payload)
    yield put(growsmartModule.updateSponsorshipSuccess(updatedReg))

    const { navigate } = payload
    return navigate('/dashboard/sponsorships')
  } catch (err) {
    yield put(growsmartModule.updateSponsorshipFailure())
  }
}

function* updateScholarshipApplication({ payload }) {
  try {
    const formDataVals = new FormData()

    Object.keys(payload).map(value => {
      if (payload[value] && value !== 'navigate') {
        formDataVals.append(value, payload[value])
      }
    })

    const response = yield call(growsmartApi.updateScholarshipApplication, formDataVals)
    yield put(growsmartModule.updateScholarshipApplicationSuccess(response.data))

    const { navigate } = payload
    yield navigate(`/dashboard/scholarships/${payload.gs_scholarship_id}/applications`)
  } catch (err) {
    yield put(growsmartModule.updateScholarshipApplicationFailure())
  }
}

function* deleteSponsorship({ payload }) {
  try {
    const response = yield call(growsmartApi.deleteSponsorship, payload)
    yield put(growsmartModule.deleteSponsorshipSuccess(response.data))
    UrlBuilder.displayDeleteSuccessMessage()
  } catch (err) {
    yield put(growsmartModule.deleteSponsorshipFailure(err))
  }
}

function* bulkUpdateHardcopySubmissions({ payload }) {
  try {
    const updatedResult = yield call(growsmartApi.bulkUpdateHardcopySubmissions, payload)
    yield put(growsmartModule.bulkUpdateHardcopySubmissionsSuccess(updatedResult))
    yield window.location.reload()
  } catch (err) {
    yield put(growsmartModule.bulkUpdateHardcopySubmissionsFailure())
  }
}

function* bulkUpdateSchools({ payload }) {
  try {
    const updatedResult = yield call(growsmartApi.bulkUpdateSchools, payload)
    yield put(growsmartModule.bulkUpdateSchoolsSuccess(updatedResult))
    yield window.location.reload()
  } catch (err) {
    yield put(growsmartModule.bulkUpdateSchoolsFailure())
  }
}

function* updateRsvp({ payload }) {
  try {
    const updatedRsvp = yield call(growsmartApi.updateRsvp, payload)
    yield put(growsmartModule.updateRsvpSuccess(updatedRsvp))
  } catch (err) {
    yield put(growsmartModule.updateRsvpFailure())
  }
}

function* updateEnrolment({ payload }) {
  try {
    const formDataVals = new FormData()

    Object.keys(payload).map(value => {
      if (payload[value]) {
        formDataVals.append(value, payload[value])
      }
    })

    const updatedEnrolment = yield call(growsmartApi.updateEnrolment, formDataVals)
    yield put(growsmartModule.updateEnrolmentSuccess(updatedEnrolment))

    const { navigate } = payload
    yield navigate('/dashboard/enrolments')
  } catch (err) {
    if (err.response.status === 403) {
      yield put(
        growsmartModule.updateEnrolmentFailure({
          errorMessage:
            'The learner you have tried to add has already participated in a Growsmart competition and cannot be added. Please reload the page and try adding a different learner.'
        })
      )
    } else {
      yield put(growsmartModule.updateEnrolmentFailure(err.response.data))
    }
  }
}

function* manualRegistration({ payload }) {
  try {
    const formDataVals = new FormData()

    Object.keys(payload).map(value => {
      if (payload[value]) {
        formDataVals.append(value, payload[value])
      }
    })

    const registration = yield call(growsmartApi.manualRegistration, formDataVals)
    yield put(growsmartModule.manualRegistrationSuccess(registration))
    window.location.reload()
  } catch (err) {
    yield put(growsmartModule.manualRegistrationFailure(err.response.data))
  }
}

function* updateEnrolmentAsParent({ payload }) {
  try {
    const formDataVals = new FormData()

    Object.keys(payload).map(value => {
      if (payload[value]) {
        formDataVals.append(value, payload[value])
      }
    })

    const updatedEnrolment = yield call(growsmartApi.updateEnrolmentAsParent, formDataVals)
    yield put(growsmartModule.updateEnrolmentAsParentSuccess(updatedEnrolment))
  } catch (err) {
    yield put(growsmartModule.updateEnrolmentAsParentFailure())
  }
}

function* updateRegistration({ payload }) {
  try {
    const updatedReg = yield call(growsmartApi.updateRegistration, payload)
    yield put(growsmartModule.updateRegistrationSuccess(updatedReg))
  } catch (err) {
    yield put(growsmartModule.updateRegistrationFailure())
  }
}

function* closeRound({ payload }) {
  try {
    yield call(growsmartApi.closeRound, payload)
    window.location.reload()
  } catch (err) {
    yield put(growsmartModule.closeRoundFailure())
  }
}

function* updateRoundMarks({ payload }) {
  try {
    yield call(growsmartApi.updateRoundMarks, payload)
    window.location.reload()
  } catch (err) {
    yield put(growsmartModule.updateRoundMarksFailure())
  }
}

function* launchComp({ payload }) {
  try {
    yield call(growsmartApi.launchComp, payload)
    window.location.reload()
  } catch (err) {
    yield put(growsmartModule.launchCompFailure())
  }
}

export const growsmartSagas = [
  takeLatest(growsmartModule.INVITE_MENTOR, inviteMentor),
  takeLatest(growsmartModule.FETCH_REGISTRATIONS, fetchRegistrations),
  takeLatest(growsmartModule.MANUAL_REGISTRATION, manualRegistration),
  takeLatest(growsmartModule.FETCH_DISTRICTS, fetchDistricts),
  takeLatest(growsmartModule.FETCH_RSVPS, fetchRsvps),
  takeLatest(growsmartModule.FETCH_ENROLMENT, fetchEnrolment),
  takeLatest(growsmartModule.FETCH_ENROLMENTS, fetchEnrolments),
  takeLatest(growsmartModule.FETCH_SPONSORSHIP, fetchSponsorship),
  takeLatest(growsmartModule.FETCH_SPONSORSHIPS, fetchSponsorships),
  takeLatest(growsmartModule.CREATE_SPONSORSHIP, createSponsorship),
  takeLatest(growsmartModule.DELETE_SPONSORSHIP, deleteSponsorship),
  takeLatest(growsmartModule.UPDATE_SPONSORSHIP, updateSponsorship),
  takeLatest(growsmartModule.FETCH_SCHOLARSHIP, fetchScholarship),
  takeLatest(growsmartModule.FETCH_SCHOLARSHIPS, fetchScholarships),
  takeLatest(growsmartModule.DELETE_SCHOLARSHIP, deleteScholarship),
  takeLatest(growsmartModule.CREATE_SCHOLARSHIP, createScholarship),
  takeLatest(growsmartModule.UPDATE_SCHOLARSHIP, updateScholarship),
  takeLatest(growsmartModule.APPLY_TO_SCHOLARSHIP, applyToScholarship),
  takeLatest(growsmartModule.UPDATE_SCHOLARSHIP_APPLICATION, updateScholarshipApplication),
  takeLatest(growsmartModule.FETCH_SCHOLARSHIP_APPLICATION, fetchScholarshipApplication),
  takeLatest(growsmartModule.FETCH_SCHOLARSHIP_APPLICATIONS, fetchScholarshipApplications),
  takeLatest(growsmartModule.FETCH_SCHOOLS_FOR_PROVINCE, fetchSchoolsForProvince),
  takeLatest(growsmartModule.FETCH_HARDCOPY_SUBMISSIONS, fetchHardcopySubmissions),
  takeLatest(growsmartModule.BULK_UPDATE_HARDCOPY_SUBMISSIONS, bulkUpdateHardcopySubmissions),
  takeLatest(growsmartModule.BULK_UPDATE_SCHOOLS, bulkUpdateSchools),
  takeLatest(growsmartModule.UPDATE_RSVP, updateRsvp),
  takeLatest(growsmartModule.UPDATE_ENROLMENT, updateEnrolment),
  takeLatest(growsmartModule.UPDATE_ENROLMENT_AS_PARENT, updateEnrolmentAsParent),
  takeLatest(growsmartModule.UPDATE_REGISTRATION, updateRegistration),
  takeLatest(growsmartModule.CLOSE_ROUND, closeRound),
  takeLatest(growsmartModule.UPDATE_ROUND_MARKS, updateRoundMarks),
  takeLatest(growsmartModule.LAUNCH_COMP, launchComp),
  takeLatest(growsmartModule.DECLINE_INVITE, declineInvite)
]
